import React, { memo } from 'react'

function Templatename({
  templatename,
  handleChange,
  handleBlur,
  templatenameerror,
  templatenametouched,
  templatelanguages,
  templatelanguageserrors,
  templatelanguagestouched,
  isEditMode = false
}) {
  console.log('Templatename select value:', templatelanguages);
  const selectValue = templatelanguages || 'notset';

  const validateTemplateName = (e) => {
    if (!e || !e.target || typeof e.target.name === 'undefined') return;
    const value = e.target.value;
    // Remove any spaces and special characters except underscore
    const sanitizedValue = value.replace(/[^a-zA-Z0-9_]/g, '');
    
    // Only update if the value has changed after sanitization
    if (value !== sanitizedValue) {
      e.target.value = sanitizedValue;
      // Create a new event with the sanitized value
      const newEvent = {
        ...e,
        target: {
          ...e.target,
          value: sanitizedValue
        }
      };
      handleChange(newEvent);
    } else {
      handleChange(e);
    }
  };

  // Debug: log language change
  const handleChangeWithLog = (e) => {
    console.log('Language changed to:', e.target.value);
    handleChange(e);
  };

  return (
    <div className='row pt-2 pr-0'>
        <div className="form-group col-lg-6 m-0">
            <div className="form-group mb-2">
                <label htmlFor="exampleInputName1">Name your template</label>
                <div className="input-group p-0">
                    <input
                        type="text" 
                        className={`form-control m-0 ${isEditMode ? 'bg-light' : ''}`}
                        name='templatename'  
                        value={templatename || ''} 
                        onChange={validateTemplateName} 
                        onBlur={handleBlur} 
                        placeholder="Enter Template Name (only letters, numbers, and underscore allowed)"
                        disabled={isEditMode}
                        title={isEditMode ? 'Template name cannot be changed in edit mode' : ''}
                    />
                    <div className="input-group-append border d-flex align-items-center px-2">
                        <span className='text-dark' style={{fontSize: '12px'}}>{(templatename ? templatename.length : 0)}/512</span>
                    </div>
                </div>
                {templatenameerror && templatenametouched ? 
                    <span className='text-danger' style={{fontSize: '13px'}}>{templatenameerror}</span>  
                    : ''}
                <small className="text-muted">
                    {isEditMode ? 'Template name cannot be changed in edit mode' : 'Only letters, numbers, and underscore (_) are allowed. Spaces and special characters will be removed.'}
                </small>
            </div>
        </div>
        <div className="form-group col-lg-6 p-0">
            <label>Select language</label>
            <select 
              className={`js-example-basic-single border w-100 input-group px-2 !mt-[8px] ${isEditMode ? 'bg-light' : ''}`} 
              onChange={handleChangeWithLog} 
              style={{cursor: isEditMode ? 'not-allowed' : 'pointer', padding: "12px 0px",marginTop:'6px',border: "1px solid red !important"}} 
              onBlur={handleBlur} 
              name="templatelanguages" 
              value={selectValue}
              disabled={isEditMode}
              title={isEditMode ? 'Template language cannot be changed in edit mode' : ''}
              
            >
              {selectValue === 'notset' && (
                <option value="notset">No language set</option>
              )}
              {templatelanguages && ![
                '', 'af', 'sq', 'ar', 'ar_EG', 'ar_AE', 'ar_LB', 'ar_MA', 'ar_QA', 'az', 'be_BY', 'bn', 'bn_IN', 'bg', 'ca', 'zh_CN', 'zh_HK', 'zh_TW', 'hr', 'cs', 'da', 'prs_AF', 'nl', 'nl_BE', 'en', 'en_GB', 'en_US', 'en_AE', 'en_AU', 'en_CA', 'en_GH', 'en_IE', 'en_IN', 'en_JM', 'en_MY', 'en_NZ', 'en_QA', 'en_SG', 'en_UG', 'en_ZA', 'et', 'fil', 'fi', 'fr', 'fr_BE', 'fr_CA', 'fr_CH', 'fr_CI', 'fr_MA', 'ka', 'de', 'de_AT', 'de_CH', 'el', 'gu', 'ha', 'he', 'hi', 'hu', 'id', 'ga', 'it', 'ja', 'kn', 'kk', 'rw_RW', 'ko', 'ky_KG', 'lo', 'lv', 'lt', 'mk', 'ms', 'ml', 'mr', 'nb', 'ps_AF', 'fa', 'pl', 'pt_BR', 'pt_PT', 'pa', 'ro', 'ru', 'sr', 'si_LK', 'sk', 'sl', 'es', 'es_AR', 'es_CL', 'es_CO', 'es_CR', 'es_DO', 'es_EC', 'es_HN', 'es_MX', 'es_PA', 'es_PE', 'es_ES', 'es_UY', 'sw', 'sv', 'ta', 'te', 'th', 'tr', 'uk', 'ur', 'uz', 'vi', 'zu'
              ].includes(templatelanguages) && (
                <option value={templatelanguages}>{templatelanguages}</option>
              )}
              <option value="">Select Template Language</option>
              <option value="af">Afrikaans</option>
              <option value="sq">Albanian</option>
              <option value="ar">Arabic</option>
              <option value="ar_EG">Arabic (EGY)</option>
              <option value="ar_AE">Arabic (UAE)</option>
              <option value="ar_LB">Arabic (LBN)</option>
              <option value="ar_MA">Arabic (MAR)</option>
              <option value="ar_QA">Arabic (QAT)</option>
              <option value="az">Azerbaijani</option>
              <option value="be_BY">Belarusian</option>
              <option value="bn">Bengali</option>
              <option value="bn_IN">Bengali (IND)</option>
              <option value="bg">Bulgarian</option>
              <option value="ca">Catalan</option>
              <option value="zh_CN">Chinese (CHN)</option>
              <option value="zh_HK">Chinese (HKG)</option>
              <option value="zh_TW">Chinese (TAI)</option>
              <option value="hr">Croatian</option>
              <option value="cs">Czech</option>
              <option value="da">Danish</option>
              <option value="prs_AF">Dari</option>
              <option value="nl">Dutch</option>
              <option value="nl_BE">Dutch (BEL)</option>
              <option value="en">English</option>
              <option value="en_GB">English (UK)</option>
              <option value="en_US">English (US)</option>
              <option value="en_AE">English (UAE)</option>
              <option value="en_AU">English (AUS)</option>
              <option value="en_CA">English (CAN)</option>
              <option value="en_GH">English (GHA)</option>
              <option value="en_IE">English (IRL)</option>
              <option value="en_IN">English (IND)</option>
              <option value="en_JM">English (JAM)</option>
              <option value="en_MY">English (MYS)</option>
              <option value="en_NZ">English (NZL)</option>
              <option value="en_QA">English (QAT)</option>
              <option value="en_SG">English (SGP)</option>
              <option value="en_UG">English (UGA)</option>
              <option value="en_ZA">English (ZAF)</option>
              <option value="et">Estonian</option>
              <option value="fil">Filipino</option>
              <option value="fi">Finnish</option>
              <option value="fr">French</option>
              <option value="fr_BE">French (BEL)</option>
              <option value="fr_CA">French (CAN)</option>
              <option value="fr_CH">French (CHE)</option>
              <option value="fr_CI">French (CIV)</option>
              <option value="fr_MA">French (MAR)</option>
              <option value="ka">Georgian</option>
              <option value="de">German</option>
              <option value="de_AT">German (AUT)</option>
              <option value="de_CH">German (CHE)</option>
              <option value="el">Greek</option>
              <option value="gu">Gujarati</option>
              <option value="ha">Hausa</option>
              <option value="he">Hebrew</option>
              <option value="hi">Hindi</option>
              <option value="hu">Hungarian</option>
              <option value="id">Indonesian</option>
              <option value="ga">Irish</option>
              <option value="it">Italian</option>
              <option value="ja">Japanese</option>
              <option value="kn">Kannada</option>
              <option value="kk">Kazakh</option>
              <option value="rw_RW">Kinyarwanda</option>
              <option value="ko">Korean</option>
              <option value="ky_KG">Kyrgyz (Kyrgyzstan)</option>
              <option value="lo">Lao</option>
              <option value="lv">Latvian</option>
              <option value="lt">Lithuanian</option>
              <option value="mk">Macedonian</option>
              <option value="ms">Malay</option>
              <option value="ml">Malayalam</option>
              <option value="mr">Marathi</option>
              <option value="nb">Norwegian</option>
              <option value="ps_AF">Pashto</option>
              <option value="fa">Persian</option>
              <option value="pl">Polish</option>
              <option value="pt_BR">Portuguese (BR)</option>
              <option value="pt_PT">Portuguese (POR)</option>
              <option value="pa">Punjabi</option>
              <option value="ro">Romanian</option>
              <option value="ru">Russian</option>
              <option value="sr">Serbian</option>
              <option value="si_LK">Sinhala</option>
              <option value="sk">Slovak</option>
              <option value="sl">Slovenian</option>
              <option value="es">Spanish</option>
              <option value="es_AR">Spanish (ARG)</option>
              <option value="es_CL">Spanish (CHL)</option>
              <option value="es_CO">Spanish (COL)</option>
              <option value="es_CR">Spanish (CRI)</option>
              <option value="es_DO">Spanish (DOM)</option>
              <option value="es_EC">Spanish (ECU)</option>
              <option value="es_HN">Spanish (HND)</option>
              <option value="es_MX">Spanish (MEX)</option>
              <option value="es_PA">Spanish (PAN)</option>
              <option value="es_PE">Spanish (PER)</option>
              <option value="es_ES">Spanish (SPA)</option>
              <option value="es_UY">Spanish (URY)</option>
              <option value="sw">Swahili</option>
              <option value="sv">Swedish</option>
              <option value="ta">Tamil</option>
              <option value="te">Telugu</option>
              <option value="th">Thai</option>
              <option value="tr">Turkish</option>
              <option value="uk">Ukrainian</option>
              <option value="ur">Urdu</option>
              <option value="uz">Uzbek</option>
              <option value="vi">Vietnamese</option>
              <option value="zu">Zulu</option>
            </select>
            {templatelanguageserrors && templatelanguagestouched ? <span className='text-danger' style={{fontSize: '13px'}}>{templatelanguageserrors}</span>  : ''}
            {isEditMode && (
              <small className="text-muted d-block mt-1">
                Template language cannot be changed in edit mode
              </small>
            )}
        </div>
    </div>
  )
}
export default memo(Templatename);